export default __webpack_public_path__ + "static/media/04.c6d6ed64.jpg";